<template>
  <div class="comment">
    <Header :showLoginBtn="false" :showSearch="false">
      <a @click="goTo()">
        <img
          class="logo"
          alt="Pinwall logo"
          :src="
            require(`../assets/img/${
              darkMode ? 'pinwall-logo-new-dark.svg' : 'pinwall-logo-new.svg'
            }`)
          "
        />
      </a>
      <b-dropdown
        v-if="user"
        position="is-bottom-left"
        :icon-left="'face'"
        class="user-dropdown"
        aria-role="list"
      >
        <b-button
          :title="user.name"
          :class="user.photo ? 'loggedin-button-image' : 'loggedin-button'"
          :icon-left="!user.photo ? 'account' : ''"
          slot="trigger"
        >
          <img class="loggedin-image" v-if="user.photo" :src="user.photo" />
        </b-button>
        <b-dropdown-item @click="userLogout" aria-role="listitem"
          >Logout</b-dropdown-item
        >
      </b-dropdown>
    </Header>
    <SocialLogin v-if="!user" />
    <div v-if="user" :style="`min-height: ${windowHeight}px`">
      <List
        v-if="view.list || windowWidth <= mobileWidth"
        :posts="pinwall.posts"
        @openComments="openComments"
        @fullscreen="fullscreen"
      ></List>
      <b-modal class="fullscreen" :active.sync="isFullscreenModalActive">
        <Post :post="post" :mode="'fullscreen'" />
      </b-modal>

      <b-modal :active.sync="isCommentModalActive">
        <Comment :postId="post ? post.id : ''" :pinwallId="pinwall.id" />
      </b-modal>
    </div>
    <Footer />
  </div>
</template>

<script>
import List from "@/components/pinwall/List";
import SocialLogin from "@/components/user/SocialLogin";
import Post from "../components/pinwall/Post";
import Comment from "../components/pinwall/Comment";
import Header from "../components/Header";
import Footer from "@/components/Footer";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { goTo } from "../mixins/goTo.js";

export default {
  name: "comment",
  components: {
    List,
    Post,
    Comment,
    Header,
    Footer,
    SocialLogin
  },
  mixins: [goTo],
  data: () => {
    return {
      sort: "",
      isFullscreenModalActive: false,
      isCommentModalActive: false,
      isSocketSubscribed: false,
      loadCommentsInterval: null,
      post: null,
      password: "",
      view: {
        grid: false,
        list: true
      }
    };
  },
  computed: {
    ...mapGetters(["pinwall", "comments", "user", "darkMode"])
  },
  watch: {
    comments: "setCommentsToPinwall"
  },
  methods: {
    ...mapActions(["loadPinwall", "loadComments"]),
    ...mapMutations(["setCommentsToPinwall"]),
    fullscreen(post) {
      this.post = post;
      this.isFullscreenModalActive = true;
    },
    openComments(post) {
      this.post = post;
      this.isCommentModalActive = true;
    },
    loadCommentItems(id) {
      this.loadComments(id).then(comments => {
        this.setCommentsToPinwall(comments);
      });

      if (!this.loadCommentsInterval) {
        this.loadCommentsInterval = setInterval(() => {
          this.loadComments(id).then(comments => {
            this.setCommentsToPinwall(comments);
          });
        }, 60000);
      }
    },
    load(password, socketEmit) {
      this.password = password || this.password;
      this.loadPinwall({
        tenant: this.tenantId,
        space: this.space,
        pinwallId: this.pinwallId,
        password: this.password,
        sort: this.sort,
        socketEmit: socketEmit
      })
        .then(pinwall => {
          this.showPassword = false;
          this.loadCommentItems(pinwall.id);

          if (!this.isSocketSubscribed) {
            this.sockets.subscribe(this.pinwall.id, () => {
              this.load(null, true);
            });
            this.isSocketSubscribed = true;
          }
        })
        .catch(() => {
          this.showPassword = true;
          this.passwordTries = this.passwordTries + 1;
        });
    }
  },
  created() {
    const params = this.$route.params;
    this.tenantId = params.tenant || "pinwall";
    this.space = params.space || null;
    this.pinwallId = params.pinwallId || null;
    this.sort = "new";
    this.password = this.$route.query.password;
    this.load();
  },
  beforeDestroy() {
    this.sockets.unsubscribe(this.pinwall.id);
    clearTimeout(this.loadCommentsInterval);
  }
};
</script>
